import { render, staticRenderFns } from "./BlubberThread.vue?vue&type=template&id=308ad6ca&"
import script from "./BlubberThread.vue?vue&type=script&lang=js&"
export * from "./BlubberThread.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/moritz/html/v4.6-hsfl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('308ad6ca')) {
      api.createRecord('308ad6ca', component.options)
    } else {
      api.reload('308ad6ca', component.options)
    }
    module.hot.accept("./BlubberThread.vue?vue&type=template&id=308ad6ca&", function () {
      api.rerender('308ad6ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/BlubberThread.vue"
export default component.exports